<template>
  <v-app>
    <MainNav />
    <v-main>
      <router-view />
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import MainNav from "./components/MainNav";
import Footer from "./components/Footer";

export default {
  name: "App",

  components: {
    MainNav,
    Footer
  },

  data: () => ({
    //
  })
};
</script>

<style lang="scss">
video {
  width: 100% !important;
  height: auto !important;
}
</style>
